<template>
  <div>
    <div class="box">
      <section>
        <b-field
          label="Select Data"
          :style="`margin: 25px;`"
        >
          <div class="block">
            <b-checkbox
              :style="`margin: 10px;`"
              v-model="selectDataToExport"
              native-value="Late Hourly"
            >
              Late Hourly
            </b-checkbox>
            <b-checkbox
              :style="`margin: 10px;`"
              v-model="selectDataToExport"
              native-value="Current Status Hourly"
            >
              Current Status Hourly
            </b-checkbox>
            <b-checkbox
              :style="`margin: 10px;`"
              v-for="(thisName , j ) in disableListDataShouldExport"
              :key="j"
              v-model="selectDataToExport"
              :native-value="thisName"
              disabled
            > {{thisName}}</b-checkbox>
          </div>
        </b-field>
      </section>
      <div class="columns is-vcentered is-multiline is-centered">
        <div class="column">
          <b-field label="Select Date">
            <b-datepicker
              v-model="whichDate"
              inline
              placeholder="Click to select..."
              icon="calendar-today"
              :icon-right="whichDate ? 'close-circle' : ''"
              icon-right-clickable
              @icon-right-click="clearDate"
              trap-focus
              :max-date="maxDate"
              range
            >
            </b-datepicker>
          </b-field>
          <b-button @click="exporToCSV(selectDataToExport)">EXPORT</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { getData } from '@/setting/getDatafromDB.js'
// import { titleText } from '@/setting/titleText.js'
import {
  // queryStackChart,
  queryHourlyStatus,
  queryLateHourly
} from '@/setting/queryText.js'

export default {
  data () {
    return {
      listDataShouldExport: ['Late Hourly', 'Current Status Hourly'],
      disableListDataShouldExport: ['Driver Late Daily'],
      selectDataToExport: [],
      whichDate: [],
      maxDate: new Date()
    }
  },
  mounted () {
    console.log(this.maxDate)
  },
  methods: {
    logdataExport () {
      console.log('selectDataToExport', this.selectDataToExport)
    },
    clearDate () {
      this.whichDate = null
    },
    mapName (_name) {
      let headers = {}
      let queryText = ''
      switch (_name) {
        case 'Late Hourly':
          headers = {
            Date: 'Day',
            Time: 'Time',
            Late: 'Late',
            'On-Time': 'On-Time'
          }
          queryText = queryLateHourly
          break
        case 'Current Status Hourly':
          headers = {
            Date: 'Day',
            Time: 'Time',
            // 'Active Driver': 'Active Driver',
            'Progress Order': 'Progress Order',
            // Issue: 'Issue',
            'Success Order': 'Success Order'
          }
          queryText = queryHourlyStatus
          break
      }

      return { headers, queryText }
    },
    async exporToCSV (name) {
      this.logdataExport()
      for (const _name of name) {
        const { headers, queryText } = this.mapName(_name)
        const dataArry = await this.formatData(queryText, _name)
        console.log('dataArry', dataArry)
        if (headers) {
          dataArry.unshift(headers)
        }
        // Convert Object to JSON
        var jsonObject = JSON.stringify(dataArry)
        var csv = this.convertToCSV(jsonObject)
        var exportedFilenmae = _name + '-export.csv'
        var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        if (navigator.msSaveBlob) {
        // IE 10+
          navigator.msSaveBlob(blob, exportedFilenmae)
        } else {
          var link = document.createElement('a')
          if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob)
            link.setAttribute('href', url)
            link.setAttribute('download', exportedFilenmae)
            link.style.visibility = 'hidden'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }
      }
    },
    async formatData (queryText, _name) {
      const fromDay = dayjs(this.whichDate[0])
      const endDay = dayjs(this.whichDate[1])
      //   const fromDay = dayjs('2021-08-30')
      //   const endDay = dayjs('2021-08-31')
      const diffDay = endDay.diff(fromDay, 'day')
      console.log(
        'Select date From',
        fromDay.format('YYYY-MM-DD'),
        'To',
        endDay.format('YYYY-MM-DD')
      )
      const temp = []
      switch (_name) {
        case 'Late Hourly':
          for (let i = 0; i <= diffDay; i++) {
            const _temp = await getData(
              fromDay.add(i, 'day').format('YYYY-MM-DD'),
              queryText
            )
            if (!_temp.getDateTimebyDate.items) {
              break
            }
            for (const item of _temp.getDateTimebyDate.items) {
              const _time = dayjs(item.dateTime).format('HH:00:00')
              if (_time === '00:00:00' || !item.latesHour.items[0]) {
                break
              }
              temp.push({
                Date: fromDay.add(i, 'day').format('YYYY-MM-DD'),
                Time: _time,
                Late: item.latesHour.items[0].late,
                'On Time': item.latesHour.items[0].notLate
              })
            }
          }
          break
        case 'Current Status Hourly':
          for (let i = 0; i <= diffDay; i++) {
            const _temp = await getData(
              fromDay.add(i, 'day').format('YYYY-MM-DD'),
              queryText
            )
            if (!_temp.getDateTimebyDate.items) {
              break
            }
            for (const item of _temp.getDateTimebyDate.items) {
              const _time = dayjs(item.dateTime).format('HH:00:00')
              if (_time === '00:00:00' || !item.statusesHour.items[0]) {
                break
              }
              temp.push({
                Date: fromDay.add(i, 'day').format('YYYY-MM-DD'),
                Time: _time,
                // 'Active Driver': item.statusesHour.items[0].activeDriver,
                'Progress Order': item.statusesHour.items[0].progressOrder,
                // Issue: item.statusesHour.items[0].issue,
                'Success Order': item.statusesHour.items[0].successOrder
              })
            }
          }
          break
      }
      //   console.log('final', temp)
      return temp
    },
    formatLateHourly () {},

    convertToCSV (objArray) {
      var array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray
      var str = ''
      for (var i = 0; i < array.length; i++) {
        var line = ''
        for (var index in array[i]) {
          if (line !== '') line += ','
          line += array[i][index]
        }
        str += line + '\r\n'
      }
      return str
    }
  }
}
</script>

<style scoped>
.titlecsv-modal-text-titel {
  padding: 5px;
  font-size: 20px;
}
</style>
